function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "search_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "search_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "search_svg__cls-1",
  cx: 14.83,
  cy: 14.83,
  r: 12.83
}), /*#__PURE__*/React.createElement("path", {
  className: "search_svg__cls-1",
  d: "M35 35L24 24"
})));

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 37"
  }, props), _ref, _ref2);
}

export default SvgSearch;